import {setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {Sound} from '../../../../shared/scripts/Sound'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {navigateToPage} from '../../../../shared/scripts/ui_utils/ClientUtils.ts'

export class UIWHeaderCoinController {
    protected readonly userCoinsDiv: HTMLDivElement
    readonly headerCoinsContainer: HTMLDivElement

    constructor() {
        this.userCoinsDiv = document.getElementById('header_profile_store_coins') as HTMLDivElement
        this.headerCoinsContainer = document.getElementById('header_profile_store_coins_container') as HTMLDivElement

        ClientUserState.registerChangeListener((userState) => {
            if(userState == undefined) return
            this.setCoins(userState.items.colonistCoins)
        })
    }

    private setCoins(coinAmount: number) {
        setElementInnerHTML(this.userCoinsDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: coinAmount}})
    }

    registerOnClickListenerForStore() {
        this.headerCoinsContainer.onclick = () => {
            if(UIUtilsEjsVariables.isUserOnDiscord) return

            Sound.playSound(Sound.SoundType.Click)
            UIWHeaderCoinController.sendHeaderCoinClickAnalytic()
            if(location.pathname == '/store') {
                const coinSection = document.getElementById('coins')
                coinSection?.scrollIntoView({behavior: 'smooth'})
                return
            }
            navigateToPage('/store', true)
        }
    }

    private static sendHeaderCoinClickAnalytic() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.HeaderCoinPlusButton,
        }
        void CA.sendAnalyticEvent(eventData)
    }
}
